// Filter a detail-tab list (projects / gifts / classifications / landing pages)
// by name or link. The list rows differ slightly per tab, so we look at every
// known "name" field.
export const affiliateLinkDetailsFilter = (data, search) => {
  const list = Array.isArray(data) ? data : [];
  const query = (search || "").trim().toLowerCase();
  if (!query) return list;

  return list.filter((item) => {
    const name =
      item.projectName ||
      item.classification ||
      item.landingPageName ||
      item.name ||
      item.title ||
      "";
    const link = item.link || "";
    return (
      name.toLowerCase().includes(query) || link.toLowerCase().includes(query)
    );
  });
};
